/* Home hero slideshow of the systems. Practice followed (NN/g, W3C carousel pattern): the heading stays, only the photo
   changes; about 6.5 s per slide, on phones too, none with reduced motion; pauses while the pointer or keyboard focus
   is on it; choosing a tab or swiping stops it, which is the way to stop it (no separate pause button, Simon 2026-10-04). */
(() => {
  const show = document.querySelector("[data-lh-show]");
  const slides = show ? [...show.querySelectorAll("[data-lh-slide]")] : [];
  if (slides.length < 2) return;
  const zone = show.closest(".lh-hero-col");
  const tabs = [...zone.querySelectorAll("[data-lh-tab]")];
  const DWELL = 6500;
  let i = 0, prog = 0, last = 0, held = false;
  let playing = !matchMedia("(prefers-reduced-motion: reduce)").matches;

  const go = (n) => {
    i = (n + slides.length) % slides.length;
    prog = 0;
    slides.forEach((s, k) => {
      const on = k === i;
      s.classList.toggle("is-on", on);
      s.toggleAttribute("aria-hidden", !on);
      s.querySelector("a")?.setAttribute("tabindex", on ? "0" : "-1");
    });
    tabs.forEach((t, k) => {
      t.classList.toggle("is-on", k === i);
      t.setAttribute("aria-current", String(k === i));
      t.style.setProperty("--p", 0);
    });
  };
  const setPlaying = (on) => { playing = on; };

  const tick = (t) => {
    const dt = last ? Math.min(t - last, 100) : 0;
    last = t;
    if (playing && !held && !document.hidden) {
      prog += dt / DWELL;
      if (prog >= 1) go(i + 1);
    }
    tabs[i].style.setProperty("--p", playing ? prog : 1);
    requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);

  tabs.forEach((t, k) => t.addEventListener("click", () => { setPlaying(false); go(k); }));
  zone.addEventListener("pointerenter", (e) => { if (e.pointerType === "mouse") held = true; });
  zone.addEventListener("pointerleave", () => { held = false; });
  zone.addEventListener("focusin", () => { held = true; });
  zone.addEventListener("focusout", (e) => { if (!zone.contains(e.relatedTarget)) held = false; });

  /* Swipe on touch screens; a swipe never opens the card's link. */
  let x0 = null, swiped = false;
  show.addEventListener("pointerdown", (e) => { x0 = e.clientX; swiped = false; });
  show.addEventListener("pointerup", (e) => {
    if (x0 === null) return;
    const dx = e.clientX - x0;
    x0 = null;
    if (Math.abs(dx) > 40) { swiped = true; setPlaying(false); go(i + (dx < 0 ? 1 : -1)); }
  });
  show.addEventListener("click", (e) => { if (swiped) { e.preventDefault(); swiped = false; } }, true);
})();
